import { Select } from "../../../atoms/Form";
import { type ConstructedSelect } from "../types";

export const FIELD_NAME_ADMIN_SELECT = "adminSelect";

const tLabel = "Please select one of the following";
const tRequired = "Selection is required";

export type AdminSelectProps = ConstructedSelect;

export const AdminSelect = ({ required, selectItems, selectProps, ...props }: AdminSelectProps) => {
  return (
    <Select
      label={tLabel}
      name={FIELD_NAME_ADMIN_SELECT}
      selectItems={selectItems}
      selectProps={{
        "data-testid": "form-field-admin-select",
        required,
        ...selectProps,
      }}
      validate={(value, _, meta) => {
        if (meta?.modified && required && !value) {
          return tRequired;
        }

        return "";
      }}
      {...props}
    />
  );
};
